<template>
  <div class="ringba-phone-number-dialog">
    <div class="ringba-phone-numbe-input">
      <v-select
        :menu-props="{ offsetY: true, offsetOverflow: true }"
        outlined
        v-model="ringbaPhoneNumber"
        filled
        return-object
        label="Ringba phone number"
        placeholder="Select a phone number"
        :items="tinymceVariables"
        :error="!!errorMessage"
        :error-messages="errorMessage">
        <template v-slot:append>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M7.41 8.58008L12 13.1701L16.59 8.58008L18 10.0001L12 16.0001L6 10.0001L7.41 8.58008Z"
              fill="#939099" />
          </svg>
        </template>
      </v-select>
    </div>

    <v-select
      :menu-props="{ offsetY: true, offsetOverflow: true }"
      outlined
      v-model="buttonType"
      filled
      label="Phone number display type"
      :items="buttonTypes">
      <template v-slot:append>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M7.41 8.58008L12 13.1701L16.59 8.58008L18 10.0001L12 16.0001L6 10.0001L7.41 8.58008Z"
            fill="#939099" />
        </svg>
      </template>
    </v-select>
  </div>
</template>

<script>
  import { VARIABLE_TYPES } from "@/constant";

  const DEFAULT_BUTTON_TYPES = [
    { value: "button", text: "As a button" },
    { value: "link-with-button", text: 'As a link + "Call Now" button' },
  ];

  export default {
    computed: {
      tinymceVariables() {
        const tinymceVariables = window.parent.tinymceVariables || window.top.tinymceVariables || [];

        return tinymceVariables
          .filter(phone => phone.phoneNumberData?.campaignName && phone.phoneNumberData?.publisherName)
          .map(phone => {
            return {
              value: phone.name,
              text: `${phone.phoneNumberData.campaignName} / ${phone.phoneNumberData.publisherName}`,
            };
          });
      },
    },
    data() {
      return {
        buttonTypes: DEFAULT_BUTTON_TYPES,
        ringbaPhoneNumber: "",
        buttonType: "button",
        errorMessage: "",
      };
    },
    watch: {
      ringbaPhoneNumber: {
        handler(newValue) {
          this.updateValue(newValue);
        },
        deep: true,
      },
      buttonType: {
        handler(newValue) {
          this.updateValue(newValue);
        },
        deep: true,
      },
    },
    beforeMount() {
      this.setupReceiveDataListener();
      this.requestData();
    },
    mounted() {
      this.ringbaPhoneNumber = this.ringbaPhoneNumber || this.tinymceVariables?.shift();
    },
    methods: {
      updateValue() {
        window.parent.postMessage(
          {
            mceAction: "updateRingbaPhoneNumberData",
            data: {
              ringbaPhoneNumber: this.ringbaPhoneNumber,
              buttonType: this.buttonType,
            },
          },
          origin,
        );
      },

      setupReceiveDataListener() {
        window.onmessage = message => {
          if (message.data.type === "errorData") {
            this.errorMessage = message.data.data;
          }
          if (message.data.type === "sendData") {
            const { data } = message.data;
            const jsonData = JSON.parse(data);
            const tinymceVariables = window.parent.tinymceVariables || window.top.tinymceVariables || [];
            const ringbaPhoneNumber = tinymceVariables.find(
              variable => variable.name === jsonData.ringbaPhoneNumber.value,
            );

            //Set default values if user exits toast window without saving (prevents JSON error)
            if (data === "undefined") {
              this.updateValue(this.ringbaPhoneNumber, this.buttonType);
            } else if (ringbaPhoneNumber.type !== VARIABLE_TYPES.PHONE_NUMBER_OLD) {
              this.ringbaPhoneNumber = jsonData.ringbaPhoneNumber;
              this.buttonType = jsonData.buttonType;
            }
          }
        };
      },
      requestData() {
        window.parent.postMessage(
          {
            mceAction: "requestData",
          },
          origin,
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  ::v-deep {
    .va-array-input__actions-wrapper {
      top: calc(50% + 14px);
      transform: translateY(-50%);
    }

    .va-array-input__item-wrapper {
      flex-direction: column !important;
      &:not(:first-child) {
        border-bottom: 2px dotted;
      }
    }
  }

  .ringba-phone-numbe-input {
    margin-bottom: 30px;
  }

  .ringba-phone-number-dialog {
    padding: 16px 12px 0px;
  }
</style>
